var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"head1"},[_c('Header')],1),_c('div',{staticClass:"subject"},[_c('Content')],1),_c('div',{staticClass:"foot"},[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }